import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppMaterialModule } from "../app.material.module";
import { DataCatalogueRoutingModule } from "./data-catalogue-routing.module";
import { DataCatalogueComponent } from "./data-catalogue.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { Routes } from "@angular/router";
import { DataTypeComponent } from "./data-type/data-type.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { ObjectViewComponent } from "./object-view/object-view.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatTreeModule} from "@angular/material/tree";
import {CdkTreeModule} from "@angular/cdk/tree";
import { FeatureViewModule } from "./feature-view/feature-view.module";
import { BusinessRulesModule } from "./business-rules/business-rules.module";
import { PropertyGroupViewModule } from "./property-group-view/property-group-view.module";
import { PropertyViewModule } from "./property-view/property-view.module";

@NgModule({
  imports: [
    CommonModule,
    DataCatalogueRoutingModule,
    AppMaterialModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatTreeModule,
    CdkTreeModule,
    FeatureViewModule,
    BusinessRulesModule,
    PropertyGroupViewModule,
    PropertyViewModule
  ],
  declarations: [
    DataCatalogueComponent,
    ObjectViewComponent
  ],
})
export class DataCatalogueModule {}
